<template>
  <div class="search-filter">
    <button
        v-for="type in types"
        :key="type"
        @click="onSelect(type)"
        @mouseover="onHover(type)"
        @mouseleave="onLeave"
        class="type-button"
        :class="getTypeClass(type)"
    >
      {{ type === 'ALL' ? 'All' : type }}
    </button>

  </div>
</template>

<script setup>
import {defineProps, ref} from 'vue'

const props = defineProps({
  selectedType: String
})
const emit = defineEmits(['update:selectedType'])

const types = ['ALL', 'Interview', 'Column', 'Video']

const onSelect = (type) => {
  emit('update:selectedType', type)
}

const getTypeClass = (type) => {
  const effectiveType = hoveredType.value === type ? type : props.selectedType

  return {
    'selected-all': effectiveType === 'ALL' && type === 'ALL',
    'selected-interview': effectiveType === 'Interview' && type === 'Interview',
    'selected-column': effectiveType === 'Column' && type === 'Column',
    'selected-video': effectiveType === 'Video' && type === 'Video',
  }
}

const hoveredType = ref(null)

const onHover = (type) => {
  hoveredType.value = type
}
const onLeave = () => {
  hoveredType.value = null
}

</script>

<style scoped>
.search-filter {
  display: flex;
  justify-content: space-around;
  gap: 10px;
  margin-bottom: 15px;
}

.type-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: clamp(74px, 8.0vw, 92px);
  height: clamp(29px, 6.0vw, 36px);

  background-color: transparent;
  border: 1px solid #878787;
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.6));
  border-radius: 5px;
  padding: 10px;
  color: #999999;

  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: clamp(11px, 2.6vw, 14px);
  letter-spacing: -0.03em;
  text-align: center;
  cursor: pointer;
  transition: all 0.5s ease;
  flex: 1;
}

/* 선택된 상태별 색상 적용 */
.selected-all {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #000;
}

.selected-interview {
  background-color: #F7BE17;
  border-color: #F7BE17;
  color: #000;
}

.selected-column {
  background-color: #0900FF;
  border-color: #0900FF;
  color: #fff;
}

.selected-video {
  background-color: #FF0042;
  border-color: #FF0042;
  color: #fff;
}
</style>
